<template lang='pug'>
  .radius
    button#radius-filter
      span {{ $t('competitors_filters.radius') }}
      span#checked-radius {{ formattedRadius }}
    b-popover(ref="filter_popover" target='radius-filter' triggers='click blur' placement='bottomright')
      .radius-wrapper
        .radius-wrapper-width-80
          div#formattedRadius {{ formattedRadius }}
          div.slider-wrapper 
          vue-slider(
            v-model='value'
            tooltip='none'
            :min="min"
            :max="max"
            :interval="interval"
            :dotSize='17'
            :dotStyle='dotStyle'
            :railStyle='railStyle'
            :processStyle='processStyle'
            @change='changedFilterValue(value)'
          )
      button.view-search-results(@click="viewSearchResults(value)") {{ $t('competitors_filters.view_search_results') }}
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  import applyFilter from '@/mixins/apply-filter'

  export default {
    components: {
      VueSlider
    },

    mixins: [applyFilter],

    props: {
      radius: {
        type: Number,
        default: 500
      },
    },

    data() {
      return {
        min: 100,
        max: 10000,
        interval: 100,
        value: this.radius,
        dotStyle: {
          background: '#18a4eb',
          'box-shadow': '0 1px 3px 0 rgba(24,147,204,0.55)'
        },
        railStyle: {
          background: '#D8DEE5',
          height: '5px'
        },
        processStyle: {
          background: '#18a4eb',
          height: '5px'
        }
      }
    },

    computed: {
      formattedRadius() {
        return `${this.value / 1000} km`
      }
    }
  }
</script>

<style lang='scss' scoped>
  @import '@/assets/css/mixins/competitors/filter.scss';

  .radius {
    #radius-filter {
      @include button-item-filter;

      #checked-radius {
        @include span-checked-item;
      }
    }
  }

  .radius-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;

    .radius-wrapper-width-80 {
      padding: 15px 0 25px 0;
      width: 80%;

      #formattedRadius {
        margin: 15px 0;
      }
    }
  }

  .view-search-results {
    @include view-search-results;
  }
</style>
